import BaseLeaveView from 'commons/views/Leave';
import {consts as LeaveRequestConsts} from 'newModels/leave-request.js';

const EmployeeLeaveView = BaseLeaveView.extend({
    _onInitializeSetLeaveRequest: function({employees = null}) {
        if (!employees) {
            throw new Error(`Don't have an employee to add a leave request to`);
        }
        this.leaveRequest.setEmployee(employees.at(0));
    },

    _onSubmitSetLeaveRequest: function() {
        this.leaveRequest.set({status: LeaveRequestConsts.STATUS_AWAITING});
    }
});

module.exports = EmployeeLeaveView;



// WEBPACK FOOTER //
// ./app/employee/views/requestLeave/Main.js